import { BaseModel } from "sjs-base-model";
import AvatarModel from "stores/profiles/models/avatar-model/AvatarModel";
import LanguageModel from "stores/profiles/models/language-model/LanguageModel";
import LightModel from "stores/profiles/models/light-model/LightModel";
import LightCountryModel from "stores/profiles/models/passport/LightCountryModel";

export default class ActorProfileModel extends BaseModel {
  public readonly avatar_thumbnails: AvatarModel = AvatarModel as any;
  public readonly birth_date: string | null = null;
  public readonly gender: string = "";
  public readonly marital_status: string | null = "";
  public readonly phone_number: string = "";
  public readonly avatar: string | null = null;
  public readonly website: string = "";
  public readonly twitter_url: string = "";
  public readonly facebook_url: string = "";
  public readonly instagram_url: string = "";
  public readonly zip_code: string = "";
  public readonly linkedin_url: string = "";
  public readonly is_student: boolean = false;
  public readonly education_level: string[] = [];
  public readonly driving_license_codes: string[] = [];
  public readonly birth_country: LightCountryModel | null = null;
  public readonly actor_slug: string | null = null;
  public readonly birth_city: LightModel | null = LightModel as any;
  public readonly birth_region: LightModel | null = LightModel as any;
  public readonly birth_subregion: LightModel | null = LightModel as any;
  public readonly living_city: LightModel | null = LightModel as any;
  public readonly living_country: LightCountryModel | null = LightCountryModel as any;
  public readonly living_region: LightModel | null = LightModel as any;
  public readonly living_subregion: LightModel | null = LightModel as any;
  public readonly last_graduation: number | null = null;
  public readonly languages: LanguageModel[] = [LanguageModel as any];

  /*
   * Client-Side properties (Not from API)
   */
  // public noneApiProperties: unknown = null;

  constructor(data: Partial<ActorProfileModel>) {
    super();

    this.update(data);
  }
}
